import { PRIVATE } from 'router/routes';

import { DEFAULT_LANGUAGE, FAQ_AVAILABLE_LANGUAGES } from 'constants/localization';
import { BASE_LINK, FAQ_ANDROID_CODE, FAQ_IOS_CODE } from 'constants/links';

import isMobile from 'helpers/isMobile';

export const getFaqLinks = (language: string) => {
    const mobilePlatform = (isMobile.iOS() && FAQ_IOS_CODE) || (isMobile.android() && FAQ_ANDROID_CODE);

    const languageCode = FAQ_AVAILABLE_LANGUAGES[language] || FAQ_AVAILABLE_LANGUAGES[DEFAULT_LANGUAGE];

    if (mobilePlatform) {
        return `${BASE_LINK}/${languageCode}?device=${mobilePlatform}`;
    }

    return `${BASE_LINK}/${languageCode}`;
};

export const getPersonalPlanLinks = (language: string) => {
    if (isMobile.any()) {
        return `https://support.yoga-go.io/${language}/articles/790018`;
    }

    return PRIVATE.PERSONAL_PLAN.path;
};
